import {
  GET_ALL_ANNOUNCEMENTS,
  GET_ANNOUNCEMENT_BY_ID,
  CREATE_ANNOUNCEMENT,
  UPDATE_ANNOUNCEMENT,
  DELETE_ANNOUNCEMENT,
} from "../actions/types";

const initialState = {
  announcementList: [],
  selectedAnnouncement: null,
  announcementSaveStatus: null,
  announcementUpdateStatus: null,
  announcementDeleteStatus: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALL_ANNOUNCEMENTS:
      return {
        ...state,
        announcementList: (action.payload.data || []).map((item) => ({
      ...item,
      announcement_id: item.announcement_id || item.id,
    })),
      };

    case GET_ANNOUNCEMENT_BY_ID:
      return {
        ...state,
        selectedAnnouncement: action.payload.data,
      };

    case CREATE_ANNOUNCEMENT:
      return {
        ...state,
        announcementSaveStatus: action.payload.success,
      };

    case UPDATE_ANNOUNCEMENT:
      return {
        ...state,
        announcementUpdateStatus: action.payload.success,
      };

    case DELETE_ANNOUNCEMENT:
      return {
        ...state,
        announcementDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}